import {
  ResourceAnalystReport,
  ResourceCaseStudy,
  ResourceDataSheet,
  ResourceEbook,
  ResourceFaq,
  ResourceInfographic,
  ResourceSolutionsbrief,
  ResourceVideo,
  ResourceWebpage,
  ResourceWhitePaper,
} from "@fastly/consistently-icons"

const ResourceIcon = (props) => {
  const type = props.type.toLowerCase()
  const Map = {
    video: <ResourceVideo {...props} />,
    "data sheet": <ResourceDataSheet {...props} />,
    webinar: <ResourceVideo {...props} />,
    "white paper": <ResourceWhitePaper {...props} />,
    "industry report": <ResourceAnalystReport {...props} />,
    ebook: <ResourceEbook {...props} />,
    "web page": <ResourceWebpage {...props} />,
    "case study": <ResourceCaseStudy {...props} />,
    faq: <ResourceFaq {...props} />,
    infographic: <ResourceInfographic {...props} />,
    "solutions brief": <ResourceSolutionsbrief {...props} />,
  }

  return type in Map ? Map[type] : Map["web page"]
}

export default ResourceIcon
